import BaseRepository from "@/services/resources/repository";
import byCollection from "@/services/resources/mixins/query-by-collection";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byCollection);
    }
}

export default Repository;
